<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="dangKy">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <h5 class="card-title text-uppercase">
              {{ $t("models.thiSinh.titleCard1") }}
            </h5>
          </div>
          <div class="form-row">
            <div class="col-md-3">
              <label for="txtHoTen"> {{ $t("models.thiSinh.hoTen") }}:* </label>
              <validation-provider :name="$t('models.thiSinh.hoTen')" rules="required" v-slot="{ errors, valid }">
                <input
                  type="text"
                  id="txtHoTen"
                  class="form-control"
                  v-model="thisinh.hoTen"
                  v-focus
                  :placeholder="$t('models.thiSinh.hoTen')"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="col-md-3">
              <label for="txtGioiTinh" class="pr-5"> {{ $t("models.thiSinh.gioiTinh") }}:*</label>
              <validation-provider :name="$t('models.thiSinh.gioiTinh')" rules="required" v-slot="{ errors, valid }">
                <select
                  class="form-control"
                  id="ddlDoiTuong"
                  v-model="thisinh.gioiTinh"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                >
                  <option :value="$t('models.thiSinh.nam')">
                    {{ $t("models.thiSinh.nam") }}
                  </option>
                  <option :value="$t('models.thiSinh.nu')">{{ $t("models.thiSinh.nu") }}</option>
                </select>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="col-md-3">
              <label for="txtNgaySinh"> {{ $t("models.thiSinh.ngaySinh") }}: * </label>
              <validation-provider rules="required" :name="$t('models.thiSinh.ngaySinh')" v-slot="{ errors, valid }">
                <date-picker
                  id="txtNgaySinh"
                  :value="thisinh.ngaySinh"
                  :placeholder="$t('models.thiSinh.ngaySinh')"
                  :classes="{
                    'is-invalid': errors[0],
                    'is-valid': valid,
                  }"
                  @callbackFunction="(value) => (thisinh.ngaySinh = value)"
                ></date-picker>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="col-md-3">
              <label for="ddlNoiSinh_MaTinh" class="pr-5"> {{ $t("models.thiSinh.noiSinh") }}:*</label>
              <validation-provider :name="$t('models.thiSinh.noiSinh')" rules="required" v-slot="{ errors, valid }">
                <v-autocomplete
                  :id="`ddlNoiSinh_MaTinh`"
                  hide-details
                  :items="tinhs"
                  :item-value="(item) => `${item.maTinh}: ${item.tenTinh}`"
                  :item-text="(item) => `${item.maTinh}: ${item.tenTinh} `"
                  outlined
                  dense
                  :success="valid === true"
                  :is-valid="!!thisinh.noiSinh"
                  :append-icon="valid ? 'mdi-check' : errors[0] ? 'mdi-alert-circle' : ''"
                  :error="errors[0] ? true : false"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  v-model="thisinh.noiSinh"
                ></v-autocomplete>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-3">
              <label for="txtDanToc"> {{ $t("models.thiSinh.danToc") }}:</label>
              <validation-provider :name="$t('models.thiSinh.danToc')" v-slot="{ errors, valid }">
                <input
                  type="text"
                  id="txtDanToc"
                  class="form-control"
                  v-model="thisinh.danToc"
                  :placeholder="$t('models.thiSinh.danToc')"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>            
            <div class="col-md-3">
              <label for="ddlDoiTuong"> {{ $t("models.thiSinh.doiTuong") }}:* </label>
              <validation-provider rules="required" :name="$t('models.thiSinh.doiTuong')" v-slot="{ errors, valid }">
                <select
                  class="form-control"
                  id="ddlDoiTuong"
                  v-model="thisinh.maDoiTuong"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                >
                  <option value="00">
                    {{ $t("models.thiSinh.notUuTien") }}
                  </option>
                  <option value="01">Có thuộc đối tượng ưu tiên</option>
                </select>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="col-md-3">
              <label for="txtSoDienThoai"> {{ $t("models.thiSinh.sdt") }}:* </label>
              <validation-provider rules="required" :name="$t('models.thiSinh.sdt')" v-slot="{ errors, valid }">
                <input
                  type="text"
                  id="txtSoDienThoai"
                  class="form-control"
                  v-model="thisinh.soDienThoai"
                  :placeholder="$t('models.thiSinh.sdt')"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="col-md-3">
              <label for="txtEmail"> {{ $t("models.thiSinh.email") }}:*</label>
              <validation-provider rules="required|email" :name="$t('models.thiSinh.email')" v-slot="{ errors, valid }">
                <input
                  type="email"
                  id="txtEmail"
                  class="form-control"
                  v-model="thisinh.email"
                  :placeholder="$t('models.thiSinh.email')"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>          
          <div class="form-row">
            <div class="col-md-3">
              <label for="txtSoCMND"> {{ $t("models.thiSinh.cmnd") }}:*</label>
              <validation-provider
                :name="$t('models.thiSinh.cmnd')"
                :rules="`required|checkExistCmnd:${thisinh.thiSinhId},${soCmnd}`"
                v-slot="{ errors, valid }"
              >
                <input
                  type="text"
                  id="txtSoCMND"
                  class="form-control"
                  v-model="thisinh.soCmnd"
                  :placeholder="$t('models.thiSinh.cmnd')"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="col-md-3">
              <label for="txtNgayCap"> {{ $t("models.thiSinh.ngayCap") }}: * </label>
              <validation-provider rules="required" :name="$t('models.thiSinh.ngayCap')" v-slot="{ errors, valid }">
                <date-picker
                  id="txtNgayCap"
                  :value="thisinh.ngayCap"
                  :placeholder="$t('models.thiSinh.ngayCap')"
                  :classes="{
                    'is-invalid': errors[0],
                    'is-valid': valid,
                  }"
                  @callbackFunction="(value) => (thisinh.ngayCap = value)"
                ></date-picker>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="col-md-6">
              <label for="txtNoiCap">{{ $t("models.thiSinh.noiCap") }}:*</label>
              <validation-provider :name="$t('models.thiSinh.noiCap')" :rules="`required`" v-slot="{ errors, valid }">
                <input
                  type="text"
                  id="txtNoiCap"
                  class="form-control"
                  v-model="thisinh.noiCap"
                  :placeholder="$t('models.thiSinh.noiCap')"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="col-md-6">
              <label for="fileCmndMatTruoc">  File scan/ảnh CMND/CCCD mặt trước:  <span v-if="screenAction == 'DangKy'">*</span> </label>
              <validation-provider
                :rules="screenAction == 'DangKy' ? 'required' : ''"
                name="File scan/ảnh CMND/CCCD mặt trước"
                v-slot="{ errors, valid }"
              >
                <v-file-input
                  id="fileCmndMatTruoc"
                  v-model="fileCmndMatTruoc"
                  outlined
                  dense
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  @change="addFileDinhKemCmnd"
                ></v-file-input>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="col-md-6">
              <label for="fileCmndMatSau">  File scan/ảnh CMND/CCCD mặt sau:  <span v-if="screenAction == 'DangKy'">*</span> </label>
              <validation-provider
                :rules="screenAction == 'DangKy' ? 'required' : ''"
                name="File scan/ảnh CMND/CCCD mặt sau"
                v-slot="{ errors, valid }"
              >
                <v-file-input
                  id="fileCmndMatSau"
                  v-model="fileCmndMatSau"
                  outlined
                  dense
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  @change="addFileDinhKemCmnd"
                ></v-file-input>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="col-md-12" v-if="screenAction != 'DangKy'">
							<ul v-html="showNameFile(thisinh.fileDinhKemCmnd.length > 0 ? thisinh.fileDinhKemCmnd: thisinh.fileCmnd)"></ul>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-12">
              <label for="txtHoKhau"> {{ $t("models.thiSinh.diaChi") }}: </label>
              <validation-provider :name="$t('models.thiSinh.diaChi')" v-slot="{ errors, valid }">
                <input
                  type="text"
                  id="txtHoKhau"
                  class="form-control"
                  v-model="thisinh.hoKhau"
                  :placeholder="$t('models.thiSinh.diaChi')"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="form-row">
              <div class="col-md-12 mb-3">
                <label for="txtDiaChiLienHe">
                  {{ $t("models.thiSinh.dcLienHe") }} *
                </label>
                <validation-provider
                  :name="$t('models.thiSinh.dcLienHe')"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <input
                    type="text"
                    id="txtDiaChiLienHe"
                    class="form-control"
                    v-model="thisinh.diaChi"
                    :placeholder="$t('models.thiSinh.dcLienHe')"
                    :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
          <div class="form-row">
            <div class="col-md-8">
              <label for="txtCoQuanCongTac"> {{ $t("models.thiSinh.coQuanCongTac") }}: </label>
              <validation-provider :name="$t('models.thiSinh.coQuanCongTac')" v-slot="{ errors, valid }">
                <input
                  type="text"
                  id="txtCoQuanCongTac"
                  class="form-control"
                  v-model="thisinh.coQuanCongTac"
                  :placeholder="$t('models.thiSinh.coQuanCongTac')"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="col-md-4">
              <label for="txtSoNamCongTac">{{ $t("models.thiSinh.soNamCongTac") }}:</label>
              <validation-provider rules="numeric" :name="$t('models.thiSinh.soNamCongTac')" v-slot="{ errors, valid }">
                <input
                  type="number"
                  id="txtSoNamCongTac"
                  class="form-control"
                  v-model="thisinh.soNamCongTac"
                  :placeholder="$t('models.thiSinh.soNamCongTac')"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>          
          <div class="form-row">
            <div class="col-md-12">
              <label for="txtSoBaiBao">
                Số bài báo đăng trên tạp chí chuyên ngành hoặc kỷ yếu hội thảo khoa học cấp trường trở lên:
              </label>
              <validation-provider :name="$t('models.thiSinh.soBaiBao')">
                <div class="row">
                  <div class="col-md-2 col-4">
                    <input
                      type="number"
                      min="0"
                      id="txtSoBaiBao"
                      class="form-control"
                      v-model="thisinh.soBaiBao"
                      :placeholder="$t('models.thiSinh.soBaiBao')"
                    />
                  </div>
                  <div class="col">
                    <v-file-input
                      hide-details
                      label="Tải minh chứng"
                      outlined
                      id="fileSoBaiBao"
                      dense
                      chips
                      multiple
                      v-model="thisinh.fileBaiBaoTypeFile"
                    ></v-file-input>
                  </div>
                </div>
              </validation-provider>
							<ul v-html="showNameFile(thisinh.fileBaiBaoTypeFile.length > 0 ? thisinh.fileBaiBaoTypeFile: thisinh.fileBaiBao)"></ul>
            </div>
            <div class="col-md-12">
              <label for="txtSoDeTai">
                Số đề tài nghiên cứu tham gia hoặc chủ nhiệm Gửi minh chứng quyết định giao nhiệm vụ và biên bản
                nghiệm thu:
              </label>
              <validation-provider :name="$t('models.thiSinh.soDeTai')">
                <div class="row">
                  <div class="col-md-2 col-4">
                    <input
                      type="number"
                      min="0"
                      id="txtSoDeTai"
                      class="form-control"
                      v-model="thisinh.soDeTai"
                      :placeholder="$t('models.thiSinh.soDeTai')"
                    />
                  </div>
                  <div class="col">
                    <v-file-input
                      label="Tải minh chứng"
                      outlined
                      hide-details
                      id="fileSoDeTai"
                      dense
                      chips
                      multiple
                      v-model="thisinh.fileDeTaiTypeFile"
                    ></v-file-input>
                  </div>
                </div>
              </validation-provider>
							<ul v-html="showNameFile(thisinh.fileDeTaiTypeFile.length > 0 ? thisinh.fileDeTaiTypeFile: thisinh.fileDeTai)"></ul>
            </div>
            <div class="col-md-12">
              <label for="txtHoTen">
                Tải minh chứng (Bằng tốt nghiệp, Bảng điểm và các giấy tờ ưu tiên nếu có): *
              </label>
              <validation-provider
                rules="required"
                name="File minh chứng"
                v-slot="{ errors, valid }"
                v-if="!checkTypeFile(thisinh.fileHocBa, 'minh_chung')"
              >
                <v-file-input
                  outlined
                  dense
                  hide-details
                  chips
                  multiple
                  v-model="thisinh.fileMinhChungTypeFile"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                ></v-file-input>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
              <validation-provider
                name="File minh chứng"
                v-slot="{ errors, valid }"
                v-if="checkTypeFile(thisinh.fileHocBa, 'minh_chung')"
              >
                <div class="message-file">
                  <span class="text-danger">
                    {{ $t("models.thiSinh.notUploadMinhChung") }}
                  </span>
                  <a
                    class="
                      font-weight-bold
                      text-primary text-decoration-underline
                    "
                    style="cursor: pointer"
                    @click="clickDownFileHoSo(dotdangkythisinh.thiSinhId)"
                  >
                    {{ $t("button.taiDay") }}
                  </a>
                </div>
                <v-file-input
                  outlined
                  hide-details
                  dense
                  chips
                  multiple
                  v-model="thisinh.fileMinhChungTypeFile"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                ></v-file-input>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
							<ul v-html="showNameFile(thisinh.fileMinhChungTypeFile.length > 0 ? thisinh.fileMinhChungTypeFile: thisinh.fileHocBa)"></ul>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <h5 class="card-title text-uppercase">
            2. Thông tin học tập
          </h5>
          <div class="form-row">
            <div class="col-md-12">
              <span style="text-decoration: underline;">Tốt nghiệp Đại học (Bằng chính xét tuyển)</span>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-4">
              <label for="txtDaiHocTotNghiep"> Trường:* </label>
              <validation-provider name="Trường" rules="required" v-slot="{ errors, valid }">
                <input
                  type="text"
                  id="txtDaiHocTotNghiep"
                  class="form-control"
                  v-model="thisinh.daiHocTotNghiep"
                  placeholder="Trường"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="col-md-4">
              <label for="txtNganhTotNghiep"> Ngành:* </label>
              <validation-provider name="Ngành" rules="required" v-slot="{ errors, valid }">
                <input
                  type="text"
                  id="txtNganhTotNghiep"
                  class="form-control"
                  v-model="thisinh.nganhTotNghiep"
                  placeholder="Ngành"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="col-md-4">
              <label for="txtChuyenNganhTotNghiep"> Chuyên ngành: </label>
              <validation-provider name="Chuyên ngành" v-slot="{ errors, valid }">
                <input
                  type="text"
                  id="txtChuyenNganhTotNghiep"
                  class="form-control"
                  v-model="thisinh.chuyenNganhTotNghiep"
                  placeholder="Chuyên ngành"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-3">
              <label for="txtHeDaoTao"> Hệ đào tạo:* </label>
              <validation-provider name="Hệ đào tạo" rules="required" v-slot="{ errors, valid }">
                <v-autocomplete
                  :id="`cbHeDaoTao`"
                  :items="hedaotaos"
                  hide-details
                  :item-value="(item) => item.heDaoTaoId"
                  :item-text="(item) => `${item.tenHeDaoTao}`"
                  label="Hệ đào tạo"
                  outlined
                  dense
                  :success="valid === true"
                  :is-valid="!!thisinh.heDaoTaoId"
                  :append-icon="valid ? 'mdi-check' : errors[0] ? 'mdi-alert-circle' : ''"
                  :error="errors[0] ? true : false"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  v-model="thisinh.heDaoTaoId"
                ></v-autocomplete>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="col-md-3">
              <label for="txtTGDaoTao"> Thời gian đào tạo (năm):* </label>
              <validation-provider name="Thời gian đào tạo (năm)" rules="required" v-slot="{ errors, valid }">
                <input
                  type="number"
                  id="txtTGDaoTao"
                  class="form-control"
                  v-model="thisinh.thoiGianDaoTao"
                  placeholder="Thời gian đào tạo (năm)"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="col-md-3">
              <label for="txtNamTotNghiep"> Năm tốt nghiệp:* </label>
              <validation-provider name="Năm tốt nghiệp" rules="required" v-slot="{ errors, valid }">
                <input
                  type="number"
                  id="txtNamTotNghiep"
                  class="form-control"
                  v-model="thisinh.namTotNghiep"
                  placeholder="Năm tốt nghiệp"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="col-md-3">
              <label for="ddXepLoaiTotNghiep"> Xếp loại tốt nhiệp:* </label>
              <validation-provider name="Xếp loại tốt nhiệp" rules="required" v-slot="{ errors, valid }">
                <select
                  class="form-control"
                  id="ddXepLoaiTotNghiep"
                  v-model="thisinh.xepLoaiTotNghiep"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                >
                  <option value="Xuất sắc">Xuất sắc</option>
                  <option value="Giỏi">Giỏi</option>
                  <option value="Khá">Khá</option>
                  <option value="Trung bình khá">Trung bình khá</option>
                  <option value="Trung bình">Trung bình</option>
                </select>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <h5 class="card-title text-uppercase">
            3. Thông tin học thạc sĩ
          </h5>
          <div class="form-row">
            <div class="col-md-4">
              <label for="coSo"> {{ $t("models.nguyenVong.coSo") }}: *</label>
              <validation-provider v-slot="{ errors, valid }" rules="required" :name="$t('models.nguyenVong.coSo')">
                <v-autocomplete
                  :id="`coSo`"
                  :items="cosoes"
                  hide-details
                  :item-value="(item) => item.coSoId"
                  :item-text="(item) => `${item.tenCoSo}`"
                  outlined
                  dense
                  :success="valid === true"
                  :append-icon="valid ? 'mdi-check' : errors[0] ? 'mdi-alert-circle' : ''"
                  :error="errors[0] ? true : false"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  @change="getNganhByCoSo"
                  v-model="coSoId"
                ></v-autocomplete>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="col-md-8">
              <label for="nganh"> Đăng ký tuyển sinh thạc sĩ ngành:* </label>
              <validation-provider v-slot="{ errors, valid }" name="Đăng ký tuyển sinh thạc sĩ ngành" rules="required">
                <v-autocomplete
                  :id="`nganh`"
                  :items="nganhByCoSoes"
                  hide-details
                  :item-value="(item) => item.nganhId"
                  :item-text="(item) => `${item.maNganh} - ${item.tenNganh}`"
                  outlined
                  dense
                  :success="valid === true"
                  :append-icon="valid ? 'mdi-check' : errors[0] ? 'mdi-alert-circle' : ''"
                  :error="errors[0] ? true : false"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  v-model="nguyenvong.nganhId"
                ></v-autocomplete>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-3">
              <label for="ddlDinhHuong"> Định hướng:* </label>
              <validation-provider v-slot="{ errors, valid }" name="Định hướng" rules="required">
                <select
                  class="form-control"
                  id="ddlDinhHuong"
                  v-model="nguyenvong.dinhHuong"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                >
                  <option value="Ứng dụng"> Ứng dụng </option>
                  <!-- <option value="Nghiên cứu"> Nghiên cứu </option> -->
                </select>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="col-md-3">
              <label for="coSo"> Đăng ký hình thức tuyển: * </label>
              <validation-provider v-slot="{ errors, valid }" name="Định hướng" rules="required">
                <select
                  class="form-control"
                  id="ddlHinhThucTuyen"
                  v-model="nguyenvong.hinhThucTuyen"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                >
                  <option value="Xét tuyển"> Xét tuyển </option>
                </select>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div> 
            <div class="col-md-6">
              <label for="coSo"> File scan/ảnh chứng chỉ ngoại ngữ: </label>
              <validation-provider v-slot="{ errors, valid }" :name="$t('models.nguyenVong.coSo')">
                <v-file-input
                  hide-details
                  outlined
                  id="chungChiNgoaiNgu"
                  chips
                  dense
                  multiple
                  v-model="nguyenvong.fileDinhKemCcnn"
                  :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                ></v-file-input>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>    
            <div class="col-md-12">
              <ul v-html="showNameFile(nguyenvong.fileDinhKemCcnn && nguyenvong.fileDinhKemCcnn.length > 0 ? nguyenvong.fileDinhKemCcnn: nguyenvong.chungChiNgoaiNgu)"></ul>
            </div>                   
          </div>
          <div class="form-row">
            <div class="col-md-12">
              <label for="hinhThucThi"> Đăng ký học ôn và thi Tiếng Anh: </label>
              <div class="form-check form-check-inline ml-3">
                <input
                  id="khongDangKy"
                  class="form-check-input"
                  type="radio"
                  checked
                  value="KHONG"
                  v-model="nguyenvong.hocThiTiengAnh"
                />
                <label for="khongDangKy" class="form-check-label">
                  Không đăng ký
                </label>
              </div>
              <div class="form-check form-check-inline ml-3">
                <input id="thiTa" class="form-check-input" type="radio" value="THI" v-model="nguyenvong.hocThiTiengAnh" />
                <label for="thiTa" class="form-check-label">
                  Thi Tiếng Anh
                </label>
              </div>
              <div class="form-check form-check-inline ml-3">
                <input id="onVaThi" class="form-check-input" type="radio" value="ONVATHI" v-model="nguyenvong.hocThiTiengAnh" />
                <label for="onVaThi" class="form-check-label">
                  Học ôn và thi Tiếng Anh
                </label>
              </div>
            </div>
          </div>
          <div class="form-row" style="background-color: #a6a8aa;">
            <div class="col-md-12">
              <span style="text-decoration: underline;">Ghi chú:</span>
              <ul>
                <li>Thí sinh điền đầy đủ thông tin ở các mục có dấu (*)</li>
                <li>
                  Ở mục Email, Điện thoại: Thí sinh hãy điền thông tin email và điện thoại thường dùng nhất để chúng tôi
                  thông tin đến bạn những thông tin quan trọng liên quan đến kỳ thi
                </li>                
                <li>
                  Thí sinh sau khi nhập các thông tin đăng ký học thạc sĩ thì nhấn vào nút "Đăng ký" dưới đây để gửi
                  thông tin hồ sơ đến Nhà trường
                </li>
                <li>
                  <span style="font-weight: bold; color: red;"> Hotline: 0986756445 (thầy Hoàng Trọng Triệu - Phòng Đào tạo) </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row mt-3">
        <div class="col-3">
          <button class="btn btn-success form-control" v-if="screenAction == 'DangKy'">
            Tiếp tục
          </button>
          <button class="btn btn-success form-control" v-else>
            {{ $t("button.chinhSua") }}
          </button>
        </div>
      </div>
    </form>
		<dialog-loader ref="dialogLoader"></dialog-loader>
  </ValidationObserver>
</template>

<script>
import DangKy from "../js/dangkycaohoc";
export default DangKy;
</script>

<style scoped></style>
